
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/virtual-account",
      function () {
        return require("private-next-pages/docs/errors/virtual-account.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/virtual-account"])
      });
    }
  